import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Kjørefeltbredde: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon' clipPath='url(#clip0_922_5170)'>
				<path
					id='Vector'
					d='M1.71603 12.0187C1.51395 11.8167 1.51395 11.4842 1.71603 11.2821L3.0002 9.99796L3.98126 10.979C4.18334 11.1811 4.51579 11.1811 4.71786 10.979C4.91994 10.7769 4.91994 10.4445 4.71786 10.2424L3.73681 9.26136L5.08617 7.912L6.06722 8.89305C6.2693 9.09513 6.60175 9.09513 6.80383 8.89305C7.00591 8.69098 7.00591 8.35852 6.80383 8.15645L5.82277 7.17539L7.17213 5.82603L8.15319 6.80709C8.35527 7.00917 8.68772 7.00917 8.88979 6.80709C9.09187 6.60501 9.09187 6.27256 8.88979 6.07048L7.90874 5.08943L9.2581 3.74007L10.2392 4.72112C10.4412 4.9232 10.7737 4.9232 10.9758 4.72112C11.1778 4.51905 11.1778 4.1866 10.9758 3.98452L9.9947 3.00346L11.2789 1.71929C11.481 1.51721 11.8134 1.51721 12.0155 1.71929L14.2807 3.98452C14.4828 4.1866 14.4828 4.51905 14.2807 4.72112L4.71786 14.284C4.51579 14.486 4.18334 14.486 3.98126 14.284L1.71603 12.0187ZM2.87309 15.3889C3.68792 16.2037 5.00794 16.2037 5.82277 15.3889L15.3889 5.82603C16.2037 5.0112 16.2037 3.69118 15.3889 2.87635L13.1269 0.611122C12.3121 -0.203707 10.9921 -0.203707 10.1772 0.611122L0.611122 10.174C-0.203707 10.9888 -0.203707 12.3088 0.611122 13.1237L2.87635 15.3889H2.87309Z'
					fill={pathFill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_922_5170'>
					<rect width='16' height='16' fill={pathFill} />
				</clipPath>
			</defs>
		</svg>
	);
};
